import cloneDeep from 'lodash/cloneDeep';
import _flatten from 'lodash/flatten';

const defaultPayload = {
  text: '%#%',// Directly pass the value
};

const generatePagination = pagination => {
  return {
    limit: pagination?.pageSize || 25,
    skip: pagination?.current > 0 ? (pagination?.current - 1) * pagination?.pageSize : 0,
  };
};

const generateQuery = filters => {
  if (!filters) {
    return {
      //query: { ...defaultPayload },
      query: {  },
    };
  }

  return {
    query: {
      //...defaultPayload,
      ...Object.entries(filters).reduce((acc, curr) => {
        if (curr[1]) {
          switch (curr[0]) {
            case 'status':
                acc.status = curr[1][0]; // Assign directly to `status`
                return acc;
            case 'note': {
                const doesTextStartWithHashTag = curr[1].startsWith('#');
                acc.note = doesTextStartWithHashTag ? curr[1] : `#${curr[1]}`; // Assign directly to `note`
                return acc;
            }
            case 'pharmacy_name':
                acc.name = curr[1]; // Assign directly to `pharmacyName`
                return acc;
            case 'pharmacy_state':
                acc.state = curr[1]; // Assign directly to `pharmacyState`
                return acc;
            default:
                return acc;
        }
        }
        return acc;
      }, {}),
    },
  };
};

const generateVariables = actions => {
  const { filters, pagination } = cloneDeep(actions);

  const pageOptions = generatePagination(pagination);
  const query = generateQuery(filters);

  return {
    ...pageOptions,
    ...query,
  };
};

export default generateVariables;
